.label {
  background-color: @ig-grey-600;
  color: @white;
  display: block;
  padding: 2px 6px;
  width: fit-content;
  margin: 0;
  z-index: 9999;
}

:host([edit-mode='false']) {
  .content {
    display: block;
    animation: host-fade-in 0.5s ease-in forwards;
  }
  @keyframes host-fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
